import React from "react";

const tutorialSteps = {
  homeOnboarding: [
    {
      target: '[data-tutorial-target="nav-home"]',
      title: "Hem",
      content: "Få en snabb överblick av matcher, lag och protokoll.",
      spotlightPadding: { x: 12, y: 12 },
      spotlightShape: "circle",
      spotlightRadius: 999,
      viewportPadding: 0,
    },
    {
      target: '[data-tutorial-target="nav-live"]',
      title: "Live",
      content: "Följ Bauhausligans matcher och resultat live.",
      spotlightPadding: { x: 12, y: 12 },
      spotlightShape: "circle",
      spotlightRadius: 999,
      viewportPadding: 0,
    },
    {
      target: '[data-tutorial-target="nav-table"]',
      title: "Tabell",
      content: "Följ lagens placeringar och poäng i tabellen.",
      spotlightPadding: { x: 12, y: 12 },
      spotlightShape: "circle",
      spotlightRadius: 999,
      viewportPadding: 0,
    },
    {
      target: '[data-tutorial-target="nav-series"]',
      title: "Serie",
      content: "Utforska säsongens lag och förare.",
      spotlightPadding: { x: 12, y: 12 },
      spotlightShape: "circle",
      spotlightRadius: 999,
      viewportPadding: 0,
    },
    {
      target: '[data-tutorial-target="nav-new"]',
      title: "Starta protokoll",
      content: "Skapa och påbörja ett matchprotokoll.",
      spotlightPadding: { x: 12, y: 12 },
      spotlightShape: "circle",
      spotlightRadius: 999,
      viewportPadding: 0,
    },
    {
      target: '[data-tutorial-target="account"]',
      title: "Mina sidor",
      content: "Hantera konto och se dina pågående och sparade protokoll.",
      spotlightPadding: { x: 12, y: 12 },
      spotlightShape: "circle",
      spotlightRadius: 999,
      viewportPadding: 0,
    },
  ],
  matches: [
    {
      target: "#featuredMatchesPrimary",
      title: "Protokoll-läge",
      content: "Här hittar du matchkort för ligans alla matcher. Klicka på en match för att se mer information och starta ett protokoll.",
    },
  ],
  myMatches: [
    {
      target: "#myMatchesTabs",
      title: "Växla vy",
      content: "Här samlas alla dina matchprotokoll.",
    },
    {
      target: "#createdProtocolsCard",
      title: "Påbörjade protokoll",
      content: "Fortsätt där du slutade genom att öppna ett påbörjat protokoll.",
    },
    {
      target: "#savedProtocolsCard",
      title: "Sparade matcher",
      content: "Här sparas dina färdigställda matchprotokoll.",
    },
  ],
  officialMatchDetail: [
    {
      target: "#startProtocolButton",
      title: "Starta protokoll",
      content: "Klicka här för att påbörja ett protokoll för det aktuella matchkortet.",
    },
  ],
  matchProtocol: [
    {
      target: "#matchProtocolOverview",
      title: "Matchöversikt",
      content: (
        <div>
          <p>
            Här visas poängställningen baserat på ditt matchprotokoll.
          </p>
        </div>
      ),
    },
    {
      target: "#matchStatisticsButton",
      title: "Översikt matchstatistik",
      content: (
        <div>
          <p>
            Med tiden som du för protokollet kommer du kunna ta del av snabb statistik.
          </p>
        </div>
      ),
    },
    {
      target: "#protocolViewToggle",
      title: "Växla vy",
      content: (
        <div>
          <p>
            Växla mellan heatkort och tabellvy för olika visningslägen.
          </p>
        </div>
      ),
    },
    {
      target: "#matchHeatsCarousel",
      title: "Vy - Heatkort",
      content: (
        <div>
          <p>
            Navigera ett heat i taget. Förarnas registrerade resultat visas i respektive förarkort för varje heat.
          </p>
        </div>
      ),
    },
    {
      target: "#riderPointsToggle",
      title: "Förarpoäng",
      content: (
        <div>
          <p>
            Växla mellan att visa förarnas heatpoäng eller totalpoäng.
          </p>
        </div>
      ),
    },
    // {
    //   target: "#protocolViewToggle",
    //   title: "Växla vy",
    //   content: (
    //     <div>
    //       <p>
    //         Du kan växla mellan Heatkort och Tabellvy beroende på hur du vill arbeta i protokollet.
    //       </p>
    //     </div>
    //   ),
    // },
    {
      target: "#matchProtocolTableView",
      title: "Vy - Tabellvy",
      content: (
        <div>
          <p>
            En klassisk protokollvy där hela matchen presenteras samlat för tydlig överblick.
          </p>
        </div>
      ),
    },
    {
      target: "#protocolPrimaryAction",
      title: "Registrera heat",
      content: (
        <div>
          <p>
            Använd den här knappen för att fortsätta till nästa heat. När du trycker öppnas
            heatdialogen där du registrerar resultatet.
          </p>
        </div>
      ),
    },
  ],
  heatDialog: [
    {
      target: "#heatDialogContent",
      title: "Heatregistrering",
      content: (
        <div>
          <p>
            Överblick av heatet med förare, banor och status.
          </p>
        </div>
      ),
    },
    // {
    //   target: "#heatDialogRiderList",
    //   title: "Förare och resultat",
    //   content: (
    //     <div>
    //       <p>
    //         Här registrerar du resultat för varje förare i heatet med ett enkelt tryck.
    //       </p>
    //     </div>
    //   ),
    // },
    {
      target: "#heatDialogTools",
      title: "Manuella ändringar",
      content: (
        <div>
          <p>
            Använd för att låsa upp och fritt hantera byten av förare i heatet, t.ex. R.R, när reglerna kräver det.
          </p>
        </div>
      ),
    },
    // {
    //   target: "#heatDialogActions",
    //   title: "Spara heatet",
    //   content: (
    //     <div>
    //       <p>
    //         Avsluta genom att spara resultatet eller avbryt om du vill lämna dialogen utan
    //         ändringar.
    //       </p>
    //     </div>
    //   ),
    // },
  ],
  protocolWidget: [
    {
      target: "#protocolResumeWidget",
      title: "Pågående protokoll",
      content: "När du minimerar ett protokoll visas widgeten här så du snabbt kan återuppta.",
    },
    {
      target: "#protocolResumeWidget",
      title: "Flytta widgeten",
      content: "Flytta widgeten genom att hålla ned och dra den till önskad sida.",
    },
  ],
};

export default tutorialSteps;
